module.exports = __webpack_public_path__ + "static/img/an2.a6c76cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/an2.png
// module id = j+4m
// module chunks = 0